import clsx from 'clsx';
import React from 'react';

import s from './shared.module.less';

export const CommaSeparated: React.FC<React.HTMLAttributes<HTMLSpanElement>> = ({ className, children, ...rest }) => (
  <span {...rest} className={clsx(s.commaSeparated, className)}>
    {children}
  </span>
);
